var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBtn',{attrs:{"icon":"mdi-plus","title":"Product"},on:{"click":_vm.create}})
}
var staticRenderFns = []

export { render, staticRenderFns }